import { ProductFeature, ProductCardProps } from '../model/product-card.model';

export const caracteristicasAvanceFeatures: ProductFeature[] = [
  {
    icon: 'dollar-sign',
    title: 'Monto Disponible',
    description: ''
  },
  {
    icon: 'credit-card',
    title: 'Plazo de pago',
    description: ''
  },
  {
    icon: 'credit-card',
    title: 'Canal de venta',
    description: ''
  },
  {
    icon: 'arrow-down-to-line',
    title: 'Tipo de Abono',
    description: ''
  }
];

export const advanceFeatures: ProductFeature[] = [
  {
    icon: 'dollar-sign',
    title: 'Desde $20.000 y hasta $200.0000 ',
    description: 'según el cupo disponible en tu tarjeta'
  },
  {
    icon: 'clock',
    title: 'Desde 3 a 12 Cuotas fijas mensuales',
    description: ''
  },
  {
    icon: 'clock',
    title: '',
    description: '',
    descriptionList: [
      'Directo en cajas Unimarc y Super 10',
      'Directo en Whatsapp +569 5812 3297'
    ]
  },
  {
    icon: 'arrow-down-to-line',
    title: '',
    description: '',
    descriptionList: [
      'Retiro inmediato en caja',
      'Transferencia a tu cuenta bancaria en un plazo de 24hrs hábiles'
    ]
  }
];
export const superAdvanceFeatures: ProductFeature[] = [
  {
    icon: 'dollar-sign',
    title: 'hasta $4.000.000  ',
    description: 'Monto adicional al cupo sujeto a campañas mensuales'
  },
  {
    icon: 'clock',
    title: 'Entre 12 a 48 Cuotas fijas mensuales',
    description: ''
  },
  {
    icon: 'clock',
    title: '',
    description: '',
    descriptionList: [
      'Llamando al 600 390 9001',
      'Directo en Whatsapp +569 5812 3297'
    ]
  },
  {
    icon: 'arrow-down-to-line',
    title: '',
    description: '',
    descriptionList: [
      'Transferencia a tu cuenta bancaria en un plazo de 24hrs hábiles'
    ]
  }
];

export const caracteristicasAvance: ProductCardProps = {
  title: 'Características',
  features: caracteristicasAvanceFeatures,
  ctaLink: '',
  ctaText: '',
  legalLink: ''
};

export const advanceCard: ProductCardProps = {
  title: 'Avance en Efectivo',
  features: advanceFeatures,
  ctaLink: 'https://api.whatsapp.com/send?phone=56958123297&text=Hola%20Unipay%20%F0%9F%98%80',
  ctaText: 'Simula tu Avance en Efectivo',
  legalLink: '/bases-legales'
};
export const superAdvanceCard: ProductCardProps = {
  title: 'Súper Avance',
  features: superAdvanceFeatures,
  ctaLink: 'https://api.whatsapp.com/send?phone=56958123297&text=Hola%20Unipay%20%F0%9F%98%80',
  ctaText: 'Simula tu Súper Avance',
  legalLink: '/bases-legales'
};
